/* eslint-disable */
export default {
  log: 'ログ',
} as const;

// @key: @#@"log"@#@ @source: @#@"Log"@#@
